export default {
  search(form) { // MLD-6616
    return form.post(`/api/emails/search`)
      .then(response => response.data);
  },
}
